<template>
  <div class="PrecisePush-index flex h-full" v-loading="loading">
    <!-- 左半部分 -->
    <div class="overflow-auto h-full" style="width: calc(100% - 290px)">
      <!-- <ItemContainer title="样本库推送"> -->
      <div v-if="data.length === 0">
        <SamplePush
          v-if="SurveySampleCondition"
          style="height: calc(100% - 48px)"
          ref="push"
          :index="0"
          :shoBtn="shoBtn"
          :getCheckData="getCheckData"
          :SurveySampleCondition="SurveySampleCondition"
          @getData="init"
          @showBtn="showBtn"
          @hiddenBtn="hiddenBtn"
          @trueGetCheckData="trueGetCheckData"
        />
      </div>
      <div v-if="SurveySampleCondition && data.length">
        <SamplePush
          style="height: calc(100% - 48px)"
          ref="push"
          v-for="(item, index) in data"
          :key="item.id"
          :id="item.id"
          :index="index"
          :selData="item"
          :SurveySampleCondition="SurveySampleCondition"
          :shoBtn="shoBtn"
          :getCheckData="getCheckData"
          @getData="init"
          @showBtn="showBtn"
          @hiddenBtn="hiddenBtn"
          @trueGetCheckData="trueGetCheckData"
        >
        </SamplePush>
        <el-button type="primary" v-if="shoBtn" @click="addPush" style="margin: 16px">新增推送</el-button>
      </div>
      <!-- </ItemContainer> -->
    </div>

    <!-- 右半部分 -->
    <el-scrollbar wrapClass="overflow-x-hidden" class="w-290px">
      <el-card class="border-0 rounded-none h-full overflow-auto" shadow="never">
        <img src="/entrance/img/sample-quota/sample_active.png" class="banner" @click="joinActivity"/>
        <div class="title text-medium-x leading-22 font-semibold pl-6 pr-4 pt-6 pb-2 text-theme-black-850">
          样本库推送是什么：
        </div>
        <p class="text-medium leading-24 font-normal ml-6 mr-4 mb-2 text-theme-black-850">
          样本库推送是<span v-custom="'out_D74'">调研工厂</span>为每个注册用户提供的免费福利，帮您将{{'问卷' | replaceText($route.query.scene, ['Vote','SignIn','Satisfaction','Appointment'].includes($route.query.scene)?1:0)}}精准推送给
          <span class="font-medium text-theme-black-850">1000</span>
          个目标用户，助您快速回收答卷。
        </p>
        <p class="text-medium leading-24 font-normal ml-6 mr-4 mb-2 text-theme-black-850">
          样本库推送仅负责{{'问卷' | replaceText($route.query.scene, ['Vote','SignIn','Satisfaction','Appointment'].includes($route.query.scene)?1:0)}}精准推送，不保证回收答卷数量（添加
          <span class="cursor-pointer text-theme" @click="goRedEnvelopes">微信红包</span>
          可吸引更多的人查看和填写{{'问卷' | replaceText($route.query.scene, ['Vote','SignIn','Satisfaction','Appointment'].includes($route.query.scene)?1:0)}}，加快回收速度）。
        </p>
        <p class="text-medium leading-24 font-normal ml-6 mr-4 mb-6 text-theme-black-850">
          如需更快回收答卷，您可选择
          <span class="cursor-pointer text-theme" @click="goSampleService">样本服务</span>。
        </p>
        <div class="md:w-auto h-px bg-border-gray ml-6 mr-4"></div>

        <div class="title text-medium-x leading-22 font-semibold ml-6 mr-4 mt-6 mb-2 text-theme-black-850">样本库推送流程：</div>
        <p class="text-medium leading-24 font-normal ml-6 mr-4 mb-2 text-theme-black-850 flex">
          <span></span>
          <span>1、选择目标样本属性，填写推送数量。</span>
        </p>
        <p class="text-medium leading-24 font-normal ml-6 mr-4 mb-2 text-theme-black-850 flex">
          <span></span>
          <span>2、平台审核通过后，自动将{{'问卷' | replaceText($route.query.scene, ['Vote','SignIn','Satisfaction','Appointment'].includes($route.query.scene)?1:0)}}推送给目标人群。</span>
        </p>
        <p class="text-medium leading-24 font-normal ml-6 mr-4 mb-6 text-theme-black-850 flex">
          <span></span>
          <span>3、后台实时查看回收进度。</span>
        </p>
        <div class="md:w-auto h-px bg-border-gray ml-6 mr-4"></div>

        <div class="title text-medium-x leading-22 font-semibold ml-6 mr-4 mt-6 mb-2 text-theme-black-850">样本库推送优势：</div>
        <p class="ml-6 mr-4 mb-2 leading-24 text-theme-black-850 text-medium font-normal flex">
          <i class="el-icon-success text-small text-green-theme mr-1 leading-24 mt-px"></i>
          <span>
            免费推送：为您免费推送
            <span class="font-medium text-theme-black-850">1000</span>
            个目标用户。
          </span>
        </p>
        <p class="ml-6 mr-4 mb-2 leading-24 text-theme-black-850 text-medium font-normal flex">
          <i class="el-icon-success text-small text-green-theme mr-1 leading-24 mt-px"></i>
          <span>
            快速回收：
            <span class="font-medium text-theme-black-850">300</span>
            份{{'问卷' | replaceText($route.query.scene, ['Vote','SignIn','Satisfaction','Appointment'].includes($route.query.scene)?1:0)}}通常只需几小时。
          </span>
        </p>
        <p class="ml-6 mr-4 mb-2 leading-24 text-theme-black-850 text-medium font-normal flex">
          <i class="el-icon-success text-small text-green-theme mr-1 leading-24 mt-px"></i>
          <span>
            样本丰富：百万样本库，
            <span class="font-medium text-theme-black-850">8</span>
            类细分标签，全面覆盖。
          </span>
        </p>
        <p class="ml-6 mr-4 mb-2 leading-24 text-theme-black-850 text-medium font-normal flex">
          <i class="el-icon-success text-small text-green-theme mr-1 leading-24 mt-px"></i>
          <span>
            专业可靠：<span class="font-medium text-theme-black-850">12</span>
            年专业调研经验、超
            <span class="font-medium text-theme-black-850">8000</span>
            万次调查项目执行。
          </span>
        </p>
        <div class="md:w-auto h-px bg-border-gray ml-6 mr-4"></div>

        <div class="title text-medium-x leading-22 font-semibold ml-6 mr-4 mt-6 mb-2 text-theme-black-850">
          指定配额推送，咨询客服
        </div>
        <p class="text-medium leading-24 font-normal ml-6 mr-4 mb-2 text-theme-black-850">
          如您需要指定配额推送{{'问卷' | replaceText($route.query.scene, ['Vote','SignIn','Satisfaction','Appointment'].includes($route.query.scene)?1:0)}}，或有其他疑问，请微信扫码咨询客服。
        </p>
        <div class="pl-6 pr-4 pb-6 w-full box-border flex items-center">
          <img src="/assets/img/code/Mrs.Chai.png" class="normal-img" />
          <div class="ml-3 flex-1 text-small">
            <p class="w-full leading-22">
              <span class="text-theme-black-450">客服顾问：</span>
              <span class="text-theme-black-850">柴女士</span>
            </p>
            <p class="w-full leading-22">
              <span class="text-theme-black-450">联系电话：</span>
              <span class="text-theme-black-850">18511821229</span>
            </p>
          </div>
        </div>
      </el-card>
    </el-scrollbar>
  </div>
</template>

<script>
import ItemContainer from '@/components/base/ItemContainer.vue'
import SamplePush from './components/SamplePush.vue'
import GlobalConfig from '@/global/config.js'
import { getSendNumber, getSurveySampleCondition } from '@/api/wenjuan/quota.js'
import { toSurveyBaseNew } from '@/assets/js/base-platform.js'
import { getSurveyDomain } from '@/assets/js/config/env'

export default {
  name: 'PrecisePush',
  components: { SamplePush, ItemContainer },
  data() {
    return {
      shoBtn: false, //控制新增按钮的显隐
      getCheckData: true,
      data: [],
      loading: true,
      baseUrl: getSurveyDomain(),
      SurveySampleCondition: ''
    }
  },
  methods: {
    // 跳转落地页活动页面
    joinActivity() {
      toSurveyBaseNew('/sample-library-push', { returns: 'trues' })
    },
    // 控制新增页面按钮的显隐
    showBtn() {
      this.shoBtn = true
    },
    hiddenBtn() {
      this.shoBtn = false
    },
    // 新增推送的事件
    addPush() {
      let obj = { id: '0' }
      this.data.push(obj)
      this.getCheckData = false
      // 隐藏新增按钮
      this.hiddenBtn()
    },
    // 还原获取多选框数据的开关
    trueGetCheckData() {
      this.getCheckData = true
    },
    // 两个跳转页面的操作
    goRedEnvelopes() {
      this.$router.push({
        name: 'red-envelopes',
        query: {
          scene: this.$route.query.scene
        }
      })
    },
    goSampleService() {
      this.$router.push({
        name: 'sample-service',
        query: {
          scene: this.$route.query.scene
        }
      })
    },
    async getData() {
      await getSendNumber({ surveyId: GlobalConfig.getSurveyId() })
        .then(res => {
          if (res.data.code === 0) {
            this.data = res.data.data
            this.loading = false
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    async getSelData() {
      await getSurveySampleCondition()
        .then(res => {
          this.SurveySampleCondition = JSON.parse(JSON.stringify(res.data.data))
        })
        .catch(err => {
          console.log(err)
        })
    },
    async init() {
      await this.getSelData()
      await this.getData()
    }
  },
  created() {
    this.init()
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-card__body {
  @apply p-0 h-full;
}
.title::before {
  content: '';
  @apply bg-theme block float-left w-1 h-5 -ml-6;
}
::v-deep .el-scrollbar__view {
  @apply h-full;
}
::v-deep .item-container {
  .el-card {
    @apply mb-0;
  }
}
.banner {
  width: 282px;
  cursor: pointer;
}
</style>
